import { useConfig } from "@common/composable/useMetaDataStore";
import { useAuth } from "@common/composable/useRootStore";
import { buildDownloadUrl, safeDownload } from "@common/util/downloadCore";

export const useFiles = () => {
  const { config } = useConfig();
  const { auth } = useAuth();

  const triggerFileDownloadViaEndpoint = (endpoint: string, params?: Record<string, any>) => {
    const url = buildDownloadUrl(config.value.apiUrl, endpoint, auth.value.token, params);
    safeDownload(url);
  };

  return { triggerFileDownloadViaEndpoint };
};
